import { createSlice } from '@reduxjs/toolkit';
export var initialState = {
  paymentMethods: []
};
var commandSlice = createSlice({
  name: 'commands',
  initialState: initialState,
  reducers: {
    savePaymentMethodsCommands: function savePaymentMethodsCommands(_, _ref) {
      var payload = _ref.payload;
      return {
        paymentMethods: payload
      };
    },
    clearPaymentMethodsCommands: function clearPaymentMethodsCommands() {
      return initialState;
    }
  }
});
export default commandSlice.reducer;
var _commandSlice$actions = commandSlice.actions,
  savePaymentMethodsCommands = _commandSlice$actions.savePaymentMethodsCommands,
  clearPaymentMethodsCommands = _commandSlice$actions.clearPaymentMethodsCommands;
export { savePaymentMethodsCommands, clearPaymentMethodsCommands };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/redux/command/command.slice.js
// module id = 197
// module chunks = 11